import { Component, computed, inject, input } from '@angular/core';
import { GraphComponent, lineGraphStyle } from '../../../../components/graph/graph.component';
import { ChartOptions, ChartType, TooltipItem } from 'chart.js';
import { CardComponent } from '../../../../components/card/card.component';
import { LanguageService } from '../../../../state/language/language.service';
import { fillMissingDates } from '../../../../utils/date/date';

interface FeedbackGraphData {
  date: string;
  count: number;
}
@Component({
  selector: 'app-feedback-graph',
  imports: [GraphComponent, CardComponent],
  templateUrl: './feedback-graph.component.html',
  styleUrl: './feedback-graph.component.css',
})
export class FeedbackGraphComponent {
  private languageService = inject(LanguageService);
  public feedback = input.required<FeedbackGraphData[] | undefined>();
  public data = computed(() => {
    const feedback = this.feedback();
    if (!feedback) return;

    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 30);
    const endDate = new Date();
    const filledData = fillMissingDates(feedback, startDate, endDate);

    return {
      datasets: [
        { data: filledData.map((v) => v.count), label: $localize`Feedback given`, ...lineGraphStyle, fill: 'none' },
      ],
      labels: filledData.map((v) => v.date),
    };
  });
  public options: ChartOptions<ChartType> = {
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: (context: TooltipItem<ChartType>[]) =>
            new Date(context[0].label).toLocaleString(this.languageService.getCurrentLocale(), {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
            }),
        },
      },
    },
    scales: {
      x: {
        type: 'time' as const,
        time: {
          unit: 'day' as const,
          displayFormats: { day: 'DD.MM' },
        },
      },
    },
  };
}
